export{a as apiConfig,f as featureToggles}from"./feature-toggles-e9cc698c.js";import"next/config";import"@swc/helpers";import"@grandvisionhq/state";
//# sourceMappingURL=configuration.js.map
